/**
 * Vista: Lista de Órdenes de Trabajo
 * Formato: AMX-PR-FR-01
 */

import produccionService from '../services/produccion.service.js';
import router from '../router/router.js';
import permisos from '../services/permissions.service.js';

export default {
  async render() {
    return `
      <div class="card">
        <div class="card-header" style="display: flex; justify-content: space-between; align-items: center;">
          <h2 class="card-title">Órdenes de Trabajo</h2>
          ${permisos.canCreate('ordenes') ? `
            <button class="btn btn-primary" onclick="router.navigate('/produccion/ordenes-trabajo/nueva')">
              + Nueva Orden
            </button>
          ` : ''}
        </div>

        <!-- Estadísticas rápidas -->
        <div id="statsContainer" class="stats-container" style="display: grid; grid-template-columns: repeat(auto-fit, minmax(120px, 1fr)); gap: 1rem; margin-bottom: 1.5rem;">
          <div class="stat-card" style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; text-align: center;">
            <div class="stat-value" id="statTotal" style="font-size: 1.5rem; font-weight: bold;">-</div>
            <div class="stat-label" style="color: var(--text-muted); font-size: 0.875rem;">Total</div>
          </div>
          <div class="stat-card" style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; text-align: center;">
            <div class="stat-value" id="statAbiertas" style="font-size: 1.5rem; font-weight: bold; color: var(--info);">-</div>
            <div class="stat-label" style="color: var(--text-muted); font-size: 0.875rem;">Abiertas</div>
          </div>
          <div class="stat-card" style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; text-align: center;">
            <div class="stat-value" id="statCompletadas" style="font-size: 1.5rem; font-weight: bold; color: var(--success);">-</div>
            <div class="stat-label" style="color: var(--text-muted); font-size: 0.875rem;">Completadas</div>
          </div>
          <div class="stat-card" style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; text-align: center;">
            <div class="stat-value" id="statGarantia" style="font-size: 1.5rem; font-weight: bold; color: var(--primary);">-</div>
            <div class="stat-label" style="color: var(--text-muted); font-size: 0.875rem;">En Garantía</div>
          </div>
        </div>

        <!-- Filtros -->
        <div class="filters" style="display: grid; grid-template-columns: repeat(auto-fit, minmax(180px, 1fr)); gap: 1rem; margin-bottom: 1.5rem;">
          <div class="form-group">
            <label class="form-label">Buscar</label>
            <input
              type="text"
              id="busqueda"
              class="form-input"
              placeholder="Num. Serie, Usuario..."
            />
          </div>

          <div class="form-group">
            <label class="form-label">Estado</label>
            <select id="estadoFilter" class="form-select">
              <option value="">Todos</option>
              <option value="abierta">Abierta</option>
              <option value="completada">Completada</option>
            </select>
          </div>

          <div class="form-group">
            <label class="form-label">Tipo</label>
            <select id="tipoFilter" class="form-select">
              <option value="">Todos</option>
              <option value="mantenimiento">Mantenimiento</option>
              <option value="reparacion">Reparación</option>
              <option value="observacion">Observación</option>
            </select>
          </div>

          <div class="form-group">
            <label class="form-label">Garantía</label>
            <select id="garantiaFilter" class="form-select">
              <option value="">Todas</option>
              <option value="true">En Garantía</option>
              <option value="false">Sin Garantía</option>
            </select>
          </div>

          <div class="form-group">
            <label class="form-label">Desde</label>
            <input type="date" id="fechaDesde" class="form-input" />
          </div>

          <div class="form-group" style="display: flex; align-items: flex-end;">
            <button class="btn btn-secondary" onclick="window.ordenesTrabajoListView.limpiarFiltros()" style="width: 100%;">
              Limpiar
            </button>
          </div>
        </div>

        <!-- Tabla -->
        <div class="table-container">
          <table class="table">
            <thead>
              <tr>
                <th></th>
                <th>ID</th>
                <th class="tbl-hide-mobile">Fecha</th>
                <th class="tbl-hide-mobile">Num. Serie</th>
                <th class="tbl-hide-mobile">Tipo</th>
                <th class="tbl-hide-mobile">Usuario</th>
                <th class="tbl-hide-mobile">Garantía</th>
                <th class="tbl-hide-mobile">Estado</th>
                <th class="tbl-hide-mobile">Acciones</th>
              </tr>
            </thead>
            <tbody id="ordenesTableBody">
              <tr>
                <td colspan="9" style="text-align: center; padding: 2rem;">
                  Cargando órdenes de trabajo...
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Paginación -->
        <div id="pagination" class="pagination" style="margin-top: 1rem;"></div>
      </div>
    `;
  },

  async afterRender() {
    if (!permisos.canView('ordenes')) {
      if (permisos.primeraRuta) {
        router.navigate(permisos.primeraRuta);
      } else {
        document.getElementById('content').innerHTML = `
          <div style="display: flex; justify-content: center; align-items: center; height: 60vh;">
            <div style="text-align: center; color: var(--primary);">
              <h2>Acceso denegado</h2>
              <p>No tienes permisos para acceder a este módulo.</p>
            </div>
          </div>
        `;
      }
      return;
    }
    window.ordenesTrabajoListView = this;

    this.currentPage = 1;
    this.limit = 10;
    this.filters = {};

    // Event listeners
    document.getElementById('busqueda').addEventListener('input', (e) => {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.filters.search = e.target.value;
        this.currentPage = 1;
        this.cargarOrdenes();
      }, 500);
    });

    document.getElementById('estadoFilter').addEventListener('change', (e) => {
      this.filters.estado = e.target.value;
      this.currentPage = 1;
      this.cargarOrdenes();
    });

    document.getElementById('tipoFilter').addEventListener('change', (e) => {
      this.filters.tipo = e.target.value;
      this.currentPage = 1;
      this.cargarOrdenes();
    });

    document.getElementById('garantiaFilter').addEventListener('change', (e) => {
      this.filters.garantia = e.target.value;
      this.currentPage = 1;
      this.cargarOrdenes();
    });

    document.getElementById('fechaDesde').addEventListener('change', (e) => {
      this.filters.fecha_desde = e.target.value;
      this.currentPage = 1;
      this.cargarOrdenes();
    });

    await this.cargarEstadisticas();
    await this.cargarOrdenes();
  },

  async cargarEstadisticas() {
    try {
      const response = await produccionService.obtenerEstadisticasOrdenes();
      const stats = response.data || response;

      document.getElementById('statTotal').textContent = stats.total || 0;
      document.getElementById('statAbiertas').textContent = stats.abiertas || 0;
      document.getElementById('statCompletadas').textContent = stats.completadas || 0;
      document.getElementById('statGarantia').textContent = stats.en_garantia || 0;
    } catch (error) {
      console.error('Error al cargar estadísticas:', error);
    }
  },

  async cargarOrdenes() {
    try {
      const params = {
        page: this.currentPage,
        limit: this.limit,
        ...this.filters
      };

      const response = await produccionService.listarOrdenesTrabajo(params);
      const ordenes = response.data || response.ordenes || response;
      const pagination = response.pagination || { page: 1, totalPages: 1, total: 0 };

      this.renderOrdenes(Array.isArray(ordenes) ? ordenes : []);
      this.renderPaginacion(pagination);
    } catch (error) {
      toast.error('Error al cargar órdenes de trabajo');
      console.error('Error:', error);
      this.renderOrdenes([]);
    }
  },

  renderOrdenes(ordenes) {
    const tbody = document.getElementById('ordenesTableBody');

    if (!ordenes || ordenes.length === 0) {
      tbody.innerHTML = `
        <tr>
          <td colspan="9" style="text-align: center; padding: 2rem;">
            No se encontraron órdenes de trabajo
          </td>
        </tr>
      `;
      return;
    }

    tbody.innerHTML = ordenes.map(o => {
      const otId = `OT-${String(o.id).padStart(4, '0')}`;
      const fechaParts = (o.fecha || '').substring(0, 10).split('-');
      const fechaStr = fechaParts.length === 3 ? `${fechaParts[2]}/${fechaParts[1]}/${fechaParts[0]}` : '-';
      const tipoBadge = `<span class="badge badge-${this.getTipoBadge(o.tipo)}">${this.formatTipo(o.tipo)}</span>`;
      const garantiaBadge = o.garantia ? '<span class="badge badge-info">Garantía</span>' : '-';
      const estadoBadge = `<span class="badge badge-${this.getEstadoBadge(o.estado)}">${this.formatEstado(o.estado)}</span>`;
      const accionesHtml = `
        ${o.estado === 'completada'
          ? (permisos.canView('ordenes') ? `<button class="btn btn-sm btn-primary" onclick="window.ordenesTrabajoListView.verDetalle(${o.id})">Ver</button>` : '')
          : `${permisos.canEdit('ordenes') ? `<button class="btn btn-sm btn-primary" onclick="window.ordenesTrabajoListView.verDetalle(${o.id})">Editar</button>` : ''}
             ${permisos.canDelete('ordenes') ? `<button class="btn btn-sm btn-danger" onclick="window.ordenesTrabajoListView.eliminar(${o.id}, '${o.num_serie}')">Eliminar</button>` : ''}`
        }
      `;
      return `
      <tr>
        <td><button class="tbl-expand-btn" onclick="window.ordenesTrabajoListView.toggleRow(${o.id})">&#9654;</button></td>
        <td><strong>${otId}</strong></td>
        <td class="tbl-hide-mobile">${fechaStr}</td>
        <td class="tbl-hide-mobile">${o.num_serie}</td>
        <td class="tbl-hide-mobile">${tipoBadge}</td>
        <td class="tbl-hide-mobile">${o.nombre_usuario || '-'}</td>
        <td class="tbl-hide-mobile">${garantiaBadge}</td>
        <td class="tbl-hide-mobile">${estadoBadge}</td>
        <td class="tbl-hide-mobile">
          <div style="display: flex; gap: 0.5rem;">${accionesHtml}</div>
        </td>
      </tr>
      <tr class="tbl-detail-row" id="detail-ot-${o.id}">
        <td colspan="9" class="tbl-detail-cell">
          <dl class="tbl-detail-grid">
            <dt>Fecha</dt><dd>${fechaStr}</dd>
            <dt>Num. Serie</dt><dd>${o.num_serie}</dd>
            <dt>Tipo</dt><dd>${tipoBadge}</dd>
            <dt>Usuario</dt><dd>${o.nombre_usuario || '-'}</dd>
            <dt>Garantía</dt><dd>${garantiaBadge}</dd>
            <dt>Estado</dt><dd>${estadoBadge}</dd>
          </dl>
          <div style="margin-top: var(--spacing-sm); display: flex; gap: var(--spacing-xs);">${accionesHtml}</div>
        </td>
      </tr>
    `}).join('');
  },

  toggleRow(id) {
    const detailRow = document.getElementById(`detail-ot-${id}`);
    const btn = detailRow?.previousElementSibling?.querySelector('.tbl-expand-btn');
    if (detailRow) {
      detailRow.classList.toggle('open');
      btn?.classList.toggle('open');
    }
  },

  getTipoBadge(tipo) {
    const badges = {
      'mantenimiento': 'info',
      'reparacion': 'warning',
      'observacion': 'secondary'
    };
    return badges[tipo] || 'secondary';
  },

  formatTipo(tipo) {
    const tipos = {
      'mantenimiento': 'Mantenimiento',
      'reparacion': 'Reparación',
      'observacion': 'Observación'
    };
    return tipos[tipo] || tipo;
  },

  getEstadoBadge(estado) {
    const badges = {
      'abierta': 'info',
      'completada': 'success'
    };
    return badges[estado] || 'secondary';
  },

  formatEstado(estado) {
    const estados = {
      'abierta': 'Abierta',
      'completada': 'Completada'
    };
    return estados[estado] || estado;
  },

  renderPaginacion(pagination) {
    const container = document.getElementById('pagination');
    const { page, totalPages } = pagination;

    if (totalPages <= 1) {
      container.innerHTML = '';
      return;
    }

    let html = '<div style="display: flex; gap: 0.5rem; justify-content: center; align-items: center;">';

    html += `
      <button
        class="btn btn-sm btn-secondary"
        onclick="window.ordenesTrabajoListView.cambiarPagina(${page - 1})"
        ${page === 1 ? 'disabled' : ''}
      >
        Anterior
      </button>
    `;

    for (let i = 1; i <= totalPages; i++) {
      if (i === page) {
        html += `<button class="btn btn-sm btn-primary" disabled>${i}</button>`;
      } else if (i === 1 || i === totalPages || (i >= page - 2 && i <= page + 2)) {
        html += `
          <button
            class="btn btn-sm btn-secondary"
            onclick="window.ordenesTrabajoListView.cambiarPagina(${i})"
          >
            ${i}
          </button>
        `;
      } else if (i === page - 3 || i === page + 3) {
        html += '<span>...</span>';
      }
    }

    html += `
      <button
        class="btn btn-sm btn-secondary"
        onclick="window.ordenesTrabajoListView.cambiarPagina(${page + 1})"
        ${page === totalPages ? 'disabled' : ''}
      >
        Siguiente
      </button>
    `;

    html += '</div>';
    container.innerHTML = html;
  },

  cambiarPagina(page) {
    this.currentPage = page;
    this.cargarOrdenes();
  },

  limpiarFiltros() {
    document.getElementById('busqueda').value = '';
    document.getElementById('estadoFilter').value = '';
    document.getElementById('tipoFilter').value = '';
    document.getElementById('garantiaFilter').value = '';
    document.getElementById('fechaDesde').value = '';
    this.filters = {};
    this.currentPage = 1;
    this.cargarOrdenes();
  },

  verDetalle(id) {
    router.navigate(`/produccion/ordenes-trabajo/${id}`);
  },

  eliminar(id, numSerie) {
    modal.confirm(
      'Confirmar eliminación',
      `¿Está seguro de eliminar la orden de trabajo del tractor <strong>${numSerie}</strong>? Esta acción no se puede deshacer.`,
      async () => {
        try {
          await produccionService.eliminarOrdenTrabajo(id);
          toast.success('Orden de trabajo eliminada');
          await this.cargarEstadisticas();
          await this.cargarOrdenes();
        } catch (error) {
          toast.error(error.message || 'Error al eliminar orden');
          console.error(error);
        }
      }
    );
  }
};
